/* RESPONSIBLE TEAM: team-proactive-support */
import NewTourRoute from 'embercom/routes/apps/app/outbound/tour/new';

export default NewTourRoute.extend({
  tourEditRoute: 'apps.app.tours.edit',
});
